import { addEmptyOption } from "@/composables/useXsdToFormKit";
import type { InventarisationSelectOption } from "./InventarisationSelectOption";
import type { MaritalStatus, MaritalStatusDetails } from "./MaritalStatus";

type Situation = MaritalStatus["situation"];

export const situationOptions: InventarisationSelectOption<Situation>[] =
	addEmptyOption([
		{ value: "single", label: "Alleenstaand" },
		{ value: "partnership", label: "Geregistreerd partnerschap" },
		{ value: "married", label: "Getrouwd" },
		{ value: "coliving", label: "Samenwonend" },
	]);

type TermsMarried = MaritalStatusDetails["married"]["terms"];
type TermsPartnership = MaritalStatusDetails["partnership"]["terms"];

export const termsMarriedOptions: InventarisationSelectOption<TermsMarried>[] =
	addEmptyOption([
		{ value: "foregin law", label: "Buitenlands recht" },
		{ value: "prenuptial agreement", label: "Huwelijkse voorwaarden" },
		{
			value: "limited shared property",
			label: "Beperkte gemeenschap van goederen",
		},
		{ value: "shared property", label: "Gemeenschap van goederen" },
	]);

export const termsPartnershipOptions: InventarisationSelectOption<TermsPartnership>[] =
	addEmptyOption([
		{
			value: "limited shared property",
			label: "Beperkte gemeenschap van goederen",
		},
		{ value: "shared property", label: "Gemeenschap van goederen" },
	]);
